module.exports = __webpack_public_path__ + "static/media/whiteBell.e3e2ab83.svg";